import { render, staticRenderFns } from "./PartnerTagChips.vue?vue&type=template&id=6088ba76&scoped=true&"
import script from "./PartnerTagChips.vue?vue&type=script&lang=js&"
export * from "./PartnerTagChips.vue?vue&type=script&lang=js&"
import style0 from "./PartnerTagChips.vue?vue&type=style&index=0&id=6088ba76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6088ba76",
  null
  
)

export default component.exports